import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import { USER_TYPES } from "@routebot/constants";
import { getColumnValue } from "shared/util/datagrid";

import Layout from "layouts/LayoutMasterDetail";

import PersonelItem from "./Personeltem";
import { PERMISSION_TYPES } from "@routebot/constants";
import { noPersonelSchoolBlocker } from "shared/utility/blocker-conditions";
import { ROUTE_TYPES, SERVICE_TYPES } from "@routebot/constants";

const PersonelsList = () => {
  const { t } = useTranslation();
  const listName = "main_passengers";
  const itemType = "passenger";

  const {
    users,
    schools,
    schoolOptions,
    standartPersonelServices,
    shiftPersonelServices,
    DeleteUser,
    InsertUser,
    UpdateUser,
  } = useContext(StoreContext);

  const { permissions } = useContext(AuthContext);

  let pageItems = users.filter((user) => user.usertype === USER_TYPES.PERSONEL);

  // Simdilik tum userlar donuyor. Biz de burada filtreleme yapiyoruz
  // const auth = useContext(AuthContext);
  // const authSchools = auth.schools.map((school) => school.id);

  // pageItems = pageItems.filter((user) => {
  //   // user.school bir array, authSchools ile kesişim kontrolü yap
  //   if (!user.school || user.school.length === 0) return false;
  //   return user.school.some((schoolId) => authSchools.includes(schoolId));
  // });
  // Simdilik tum userlar donuyor. Biz de burada filtreleme yapiyoruz

  let listColumns = [];

  if (schoolOptions?.length > 1) {
    listColumns.push(getColumnValue("school", t("client"), schoolOptions, "school", 300));
  }

  listColumns.push({ field: "name", headerName: t("name"), width: 300 });
  listColumns.push({ field: "phonenumber", headerName: t("phone"), width: 200 });

  // Helper function to get all services (both standart and shift) for a user by type
  const getPersonelServices = (userId, routeType) => {
    try {
      const allServices = [...standartPersonelServices, ...shiftPersonelServices];
      return allServices
        .filter(
          (service) =>
            service.routeType === routeType &&
            (service.serviceType === SERVICE_TYPES.PERSONEL || service.serviceType === SERVICE_TYPES.SHIFT) &&
            service?.users?.map((user) => user.id).includes(userId),
        )
        .map((service) => service.name);
    } catch {
      return [];
    }
  };

  listColumns.push({
    field: "getonservice",
    headerName: t("pickUpService"),
    width: 300,
    valueGetter: (params) => {
      const serviceNames = getPersonelServices(params.row.id, ROUTE_TYPES.PICK_UP);
      return serviceNames?.length ? serviceNames.join(", ") : "-";
    },
    renderCell: (params) => {
      const serviceNames = getPersonelServices(params.row.id, ROUTE_TYPES.PICK_UP);
      if (!serviceNames?.length)
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            -
          </div>
        );

      return (
        <div style={{ width: "100%" }}>
          {serviceNames.map((name, index) => (
            <div
              key={index}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                marginBottom: "5px",
                marginTop: "5px",
              }}
              title={name}
            >
              {name}
            </div>
          ))}
        </div>
      );
    },
  });

  listColumns.push({
    field: "getoffservice",
    headerName: t("dropOffService"),
    width: 300,
    valueGetter: (params) => {
      const serviceNames = getPersonelServices(params.row.id, ROUTE_TYPES.DROP_OFF);
      return serviceNames?.length ? serviceNames.join(", ") : "-";
    },
    renderCell: (params) => {
      const serviceNames = getPersonelServices(params.row.id, ROUTE_TYPES.DROP_OFF);
      if (!serviceNames?.length)
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            -
          </div>
        );

      return (
        <div style={{ width: "100%" }}>
          {serviceNames.map((name, index) => (
            <div
              key={index}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                marginBottom: "5px",
                marginTop: "5px",
              }}
              title={name}
            >
              {name}
            </div>
          ))}
        </div>
      );
    },
  });

  listColumns.push({ field: "identity", headerName: t("identity"), width: 200, hide: true });
  listColumns.push({ field: "email", headerName: t("email"), width: 250, hide: true });

  if (permissions[PERMISSION_TYPES.USE_CARD_ID]) {
    listColumns.push({ field: "cardId", headerName: t("jobClass"), width: 150 });
  }

  // if (permissions[PERMISSION_TYPES.USE_DESCRIPTION]) {
  if (true) {
    listColumns.push({ field: "description", headerName: t("description"), width: 150 });
  }

  if (permissions[PERMISSION_TYPES.ACCESS_TO_SHIFTS]) {
    listColumns.push({
      field: "isshift",
      headerName: t("isshift"),
      width: 200,
      valueGetter: (params) => (params?.row?.isshift ? t("yes") : t("no")),
    });
  }

  // listColumns.push({ field: "identity", headerName: "Kimlik", width: 150 });
  // listColumns.push({ field: "address", headerName: t("address"), width: 400 });

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={PersonelItem}
      NewItemComponent={PersonelItem}
      DeleteItem={DeleteUser}
      InsertItem={InsertUser}
      UpdateItem={UpdateUser}
      hideCreateNewItemWhenSelected={true}
      blockerConditions={[noPersonelSchoolBlocker(schools)]}
    />
  );
};

export default PersonelsList;
